<template>
	<v-card style="width: 100%" color="transparent" elevation="0">
		<v-card-title class="px-1 pt-0">
			<h1>Prijzen</h1>
			<v-spacer></v-spacer>
			<v-select
				:items="priceFilterOptions"
				v-model="selectedPrice"
				label="Categorie"
				item-text="text"
				item-value="priceCat"
				single-line
				menu-props="bottom"
			></v-select>
		</v-card-title>

		<v-data-table
			v-model="selected"
			v-bind:headers="headers"
			v-bind:items="filteredItems"
			v-bind:search="search"
			hide-actions
			:rows-per-page-items="[25, 50]"
			:loading="!showTable"
			item-key="id"
		>
			<template slot-scope="props">
				<tr>
					<th
						v-for="header in props.headers"
						:key="header.text"
						:class="[
							'column sortable',
							pagination.descending ? 'desc' : 'asc',
							header.value === pagination.sortBy ? 'active' : ''
						]"
						@click="changeSort(header.value)"
					>
						<v-icon>arrow_upward</v-icon>
						{{ header.text }}
					</th>
				</tr>
			</template>
			<template slot="items" slot-scope="props">
				<tr>
					<td class="text-xs-left" @click="showPrice(props.item)">
						{{ props.item.id }}
					</td>
					<td class="text-xs-left">
						<v-edit-dialog lazy>
							{{ props.item.hours }}
							<v-text-field
								type="number"
								min="0"
								step="0.01"
								slot="input"
								label="Edit"
								v-model="props.item.hours"
								@change="updatePrice(props.item)"
								single-line
							></v-text-field>
						</v-edit-dialog>
					</td>
					<td class="text-xs-left">
						<v-edit-dialog lazy>
							{{ props.item.priceText }}
							<v-text-field
								type="text"
								slot="input"
								label="Edit"
								v-model="props.item.priceText"
								@change="updatePrice(props.item)"
								single-line
							></v-text-field>
						</v-edit-dialog>
					</td>
					<td class="text-xs-left">
						<v-menu offset-y>
							<v-btn slot="activator" color="white">{{
								getTimeUnitDescription(props.item.timeUnit)
							}}</v-btn>
							<v-list>
								<v-list-tile
									v-for="(item, index) in timeOptions"
									:key="index"
									@click="updateTimeUnit(props.item, item.value)"
								>
									<v-list-tile-title>{{ item.text }}</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</td>
					<td class="text-xs-left">
						<v-edit-dialog lazy>
							{{ props.item.price | toCurrency }}
							<v-text-field
								type="number"
								min="0"
								step="0.01"
								slot="input"
								label="Edit"
								v-model="props.item.price"
								@change="updatePrice(props.item)"
								single-line
							></v-text-field>
						</v-edit-dialog>
					</td>
					<td class="text-xs-left">{{ props.item.priceCat }}</td>
					<td class="text-xs-left">
						<v-edit-dialog lazy>
							{{ props.item.priceDescription }}
							<v-text-field
								type="text"
								slot="input"
								label="Edit"
								v-model="props.item.priceDescription"
								@change="updatePrice(props.item)"
								single-line
							></v-text-field>
						</v-edit-dialog>
					</td>
					<td class="text-xs-left">
						<v-edit-dialog lazy>
							{{ props.item.kmFree }}
							<v-text-field
								slot="input"
								type="number"
								min="0"
								step="1"
								label="Edit"
								v-model="props.item.kmFree"
								@change="updatePrice(props.item)"
								single-line
							></v-text-field>
						</v-edit-dialog>
					</td>
					<td class="text-xs-right">
						<v-btn flat icon color="pink" @click="deletePrice(props.item)">
							<v-icon>delete</v-icon>
						</v-btn>
					</td>
				</tr>
			</template>
		</v-data-table>
		<v-layout wrap>
			<v-btn color="primary" @click="addEmptyNew()">Voeg toe</v-btn>
		</v-layout>
	</v-card>
</template>
<script>
import * as utils from '@/utils/utils';
import { _ } from 'vue-underscore';
export default {
	name: 'PriceTable',
	data() {
		return {
			dialog: false,
			showTable: false,
			utils: utils,
			pagination: {
				sortBy: 'name'
			},
			items: [],
			selected: [],
			search: '',
			cacheItems: {},
			selectedPrice: null,
			priceItems: [{ text: 'State 1' }],
			headers: [
				{ text: '#', value: 'id', class: '' },
				{ text: 'Aantal', value: 'hours', class: '' },
				{ text: 'Tijdomschrijving', value: 'PriceText', class: '' },
				{ text: 'Tijdseenheid', value: 'timeUnit', class: '' },
				{ text: 'Bedrag', value: 'price', class: '' },
				{ text: 'Categorie', value: 'priceCat', class: '' },
				{ text: 'Omschrijving', value: 'priceDescription', class: '' },
				{ text: 'Km vrij', value: 'kmFree', class: '' },
				{ text: '', value: '', class: '' }
			],
			timeOptions: [
				{
					value: 'hour',
					text: 'uur'
				},
				{
					value: 'day',
					text: 'dag'
				},
				{
					value: 'week',
					text: 'week'
				},
				{
					value: 'month',
					text: 'maand'
				}
			]
		};
	},
	computed: {
		filteredItems() {
			var self = this;
			return _.filter(this.items, { priceCat: String(self.selectedPrice) });
		},
		priceFilterOptions() {
			var self = this;
			var priceCategories = [];
			var distinctCategories = _.unique(_.pluck(this.items, 'priceCat'));

			for (var i = 0; i < distinctCategories.length; i++) {
				var category = _.findWhere(_.sortBy(this.items, 'id'), {
					priceCat: distinctCategories[i]
				});

				if (!this.selectedPrice) {
					this.selectedPrice = category.priceCat;
				}

				priceCategories.push({
					priceCat: category.priceCat,
					text: category.priceCat + ' - ' + category.groupDescription
				});
			}
			return priceCategories;
		}
	},
	props: ['dataType', 'dataTimeStamp'],
	mounted: function() {
		this.getData();
	},
	watch: {
		selectedPrice(newValue) {
			this.$emit('showUnits', { priceCat: newValue });
		},
		dataTimeStamp() {
			this.getData();
		}
	},
	methods: {
		getData() {
			var self = this;
			this.showTable = false;

			utils.getData(basePath + 'api/rentunits/getPrices/').then(function(json) {
				if (json && json.data) {
					self.showTable = true;
					self.items = json.data;
					self.$emit('showUnits', {
						priceCat: self.selectedPrice
							? self.selectedPrice
							: self.items[0].priceCat
					});
				}
			});
		},
		showPrice(unit) {
			unit.edit = true;
			this.$emit('showUnit', unit);
		},
		toggleAll() {
			if (this.selected.length) this.selected = [];
			else this.selected = this.items.slice();
		},
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		updatePrice(item) {
			utils
				.setData(basePath + 'api/rentunits/updatePrices', item)
				.then(function(json) {
					if (json.data) {
						item.id = json.data;
						window.emitter.$emit('showToastMessage', {
							msg: 'Prijs opgeslagen'
						});
					}
				});
		},
		deletePrice(item) {
			let self = this;
			utils
				.setData(basePath + 'api/rentunits/deletePrice', item)
				.then(function(json) {
					if (json && json.data === true) {
						self.getData();
						if (json.data) {
							window.emitter.$emit('showToastMessage', {
								msg: 'Prijs verwijderd'
							});
						}
					}
				});
		},
		addEmptyNew(priceCat) {
			this.items.push({
				hours: '999',
				kmFree: '0',
				price: '0.00',
				timeUnit: '',
				priceCat: this.selectedPrice,
				priceDescription: '-',
				priceText: 'Omschrijving'
			});
		},
		updateTimeUnit(item, value) {
			item.timeUnit = value;
			this.updatePrice(item);
		},
		getTimeUnitDescription(timeUnit) {
			let data = _.where(this.timeOptions, { value: timeUnit });
			if (data && data.length) {
				return data[0]['text'];
			} else {
				return '';
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Prices/PriceTable.vue